

























































































































































import ModalCreatePassCode from "@/components/modal/PassCode/ModalCreatePassCode.vue";
import ModalRemovePassCode from "@/components/modal/PassCode/ModalRemovePassCode.vue";
import ModalResetPassCode from "@/components/modal/PassCode/ModalResetPassCode.vue";
import ModalViewPassCode from "@/components/modal/PassCode/ModalViewPassCode.vue";
import ModalAlertPartnerNotConnect from "@/components/modal/Payment/ModalAlertPartnerNotConnect.vue";
import ModalConfirmPaymentFail from "@/components/modal/Payment/ModalConfirmPaymentFail.vue";
import ModalConfirmPaymentSuccess from "@/components/modal/Payment/ModalConfirmPaymentSuccess.vue";
import ModalInfoToConfirmPaymentBeam from "@/components/modal/Payment/ModalInfoToConfirmPaymentBeam.vue";
import ModalInfoToConfirmPaymentChillPay from "@/components/modal/Payment/ModalInfoToConfirmPaymentChillPay.vue";
import ModalInfoToConfirmPaymentPaySolutions from "@/components/modal/Payment/ModalInfoToConfirmPaymentPaySolutions.vue";
import ModalLoadingConfirmPayment from "@/components/modal/Payment/ModalLoadingConfirmPayment.vue";
import ModalMakePayment from "@/components/modal/Payment/ModalMakePayment.vue";
import {
  AuthorityRole,
  DocumentType,
  DocumentUpdatePassCodeType,
  DocumentViewOptionType,
  FinanceType,
  LoadingStatusType,
  QRPaymentType,
  TransactionType,
} from "@/enums/enums";
import { MerchantId } from "@/helper/authenticationHelper";
import { CheckIsCustomizeDocument, GetURLName } from "@/helper/documentHelper";
import { AllowToDownloadClientSide } from "@/helper/generatePdfHelper";
import { ContactEnvelopeOnlineViewModel } from "@/model/document/contactEnvelopeModel";
import { DocumentGeneratePdfModel, DocumentIdModel, OnlineViewModel } from "@/model/document/documentModel";
import { JournalOnlineViewModel } from "@/model/document/journalDocumentModal";
import { PP30OnlineViewModel } from "@/model/document/pp30DocumentModel";
import { WitholdingTaxOnlineViewModel } from "@/model/document/witholdingTaxDocumentModal";
import { MerchantModel } from "@/model/merchant/merchantModel";
import { BeamRequestModel, GetTransactionRemainPaymentModel } from "@/model/payment/paymentModel";
import { UserModel, UserRoleModel } from "@/model/user/userModel";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StoreDisplayPaper = namespace("DisplayPaper");
const StoreAuthentication = namespace("Authentication");
const StoreDocument = namespace("Document");
const StoreGeneratePdf = namespace("GeneratePdf");
const StoreMerchant = namespace("Merchant");
const StorePayment = namespace("Payment");

@Component({
  components: {
    ModalAlertPartnerNotConnect,
    ModalConfirmPaymentFail,
    ModalConfirmPaymentSuccess,
    ModalInfoToConfirmPaymentBeam,
    ModalInfoToConfirmPaymentChillPay,
    ModalInfoToConfirmPaymentPaySolutions,
    ModalLoadingConfirmPayment,
    ModalMakePayment,
    ModalCreatePassCode,
    ModalRemovePassCode,
    ModalResetPassCode,
    ModalViewPassCode,
  },
})
export default class MobileFloatIcon extends Vue {
  @Prop({}) merchantDetail!: MerchantModel;
  @Prop({ default: false }) isAuthorized!: boolean;
  @Prop({ default: false }) isNotMerchant!: boolean;
  @Prop({ default: false }) isCanNotOpenDocument!: boolean;
  @Prop({ default: "" }) documentName!: string;
  @Prop({ default: "" }) transactionNumber!: string;
  @Prop({ default: 0 }) sourceType!: number;
  @Prop({ default: false }) isDocumentNameShort!: boolean;
  @Prop({ default: false }) widthScreen!: number;

  private langs = "en";
  private isShowMenu = false;
  private isShowMakePayment = false;
  private isShowModalLoadingConfirmPayment = false;
  private isCheckPayment = false;
  private isSetShowModalMakePayment = false;
  private isCheckPaymentAfterCloseModal = false;
  private selectedDocumentViewSettingTypeList = DocumentViewOptionType.FullScreen;
  private isShowModalInfoToConfirmPaymentPaySolutions = false;
  private isShowModalConfirmPaymentFail = false;
  private isShowModalConfirmPaymentSuccess = false;
  private isShowModalMakePayment = false;
  private isShowModalInfoToConfirmPaymentChillPay = false;
  private isShowModalAlertPartnerNotConnect = false;
  private isShowModalInfoToConfirmPaymentBeam = false;
  private isShowModalViewPassCode = false;
  private isShowModalResetPassCode = false;
  private isShowModalRemovePassCode = false;
  private isShowModalCreatePassCode = false;

  private iconOpacity = 100;
  private prevScrollY = 0;
  private isCustomize = CheckIsCustomizeDocument();

  public documentViewSettingTypeList = [
    { name: this.$t("Document_View.FullScreen"), value: DocumentViewOptionType.FullScreen },
    { name: this.$t("Document_View.Paper"), value: DocumentViewOptionType.Paper },
  ];

  get languageMobile() {
    return this.langs == "en" ? "English Version" : "ภาษาไทย";
  }

  get isMobile() {
    return this.widthScreen < 1000;
  }

  get isDocumentOtherType() {
    return (
      this.getDocumentDetail?.transactionType === DocumentType.Envelope ||
      this.getDocumentDetail?.transactionType === DocumentType.ExecutiveSummary
    );
  }

  get isSettingWithPassCode() {
    return this.getDocumentDetail?.credential.passCode !== "" && this.merchantDetail.isUsePassCodeOnPublicLink;
  }

  get isAccess() {
    return (
      this.getUserRole?.authorityRole == AuthorityRole.StandardRights ||
      this.getUserRole?.authorityRole == AuthorityRole.Admin
    );
  }

  @StoreDocument.Getter
  private getDocumentDetail!:
    | OnlineViewModel
    | JournalOnlineViewModel
    | PP30OnlineViewModel
    | WitholdingTaxOnlineViewModel
    | ContactEnvelopeOnlineViewModel
    | null;

  @StoreDisplayPaper.Getter
  private getDocumentViewOption!: DocumentViewOptionType;
  @StoreDisplayPaper.Mutation
  private SetDocumentViewOption!: (input: DocumentViewOptionType) => void;

  @StoreGeneratePdf.Action
  private DoGeneratePdf!: (input: DocumentGeneratePdfModel) => void;
  @StoreGeneratePdf.Action
  private DoGeneratePdfClientSide!: (input: DocumentGeneratePdfModel) => void;
  @StoreGeneratePdf.Action
  private DoGeneratePdfLogService!: (input: DocumentGeneratePdfModel) => void;

  @StoreMerchant.Getter
  private getMerchantQRPaymentModel!: any;
  @StoreMerchant.Action
  private DoGetCheckQRPayment!: () => void;
  @StoreMerchant.Action
  private DoGetQRPaymentSetting!: () => void;

  @StorePayment.Getter
  private getIsConfirmPayment!: boolean;
  @StorePayment.Getter
  private getTransactionRemainPaymentModel!: Record<string, any>;
  @StoreMerchant.Getter
  private getMerchantQRPaymentSettingLoadingStatus!: LoadingStatusType;
  @StorePayment.Getter
  private getTransactionRemainPaymentLoadingStatus!: LoadingStatusType;
  @StorePayment.Action
  private DoGetTransactionRemainPayment!: (input: GetTransactionRemainPaymentModel) => void;
  @StorePayment.Action
  private DoGetBeamPayment!: (input: BeamRequestModel) => void;

  @StoreAuthentication.Getter
  private getUserInfo!: UserModel | null;
  @StoreAuthentication.Getter
  private getUserRole!: UserRoleModel | null;

  @StoreDocument.Getter
  private getDocumentPassCode!: string;
  @StoreDocument.Getter
  private getDocumentLoadingStatus!: LoadingStatusType;
  @StoreDocument.Action
  private DoUpdateOnlineViewPassCode!: (input: DocumentIdModel) => void;

  created() {
    this.langs = this.langs === this.$i18n.locale ? "th" : "en";
  }

  mounted() {
    this.selectedDocumentViewSettingTypeList = this.getDocumentViewOption;
    this.prevScrollY = window.scrollY;
    // window.addEventListener("scroll", this.HandleScroll);
  }

  destroyed() {
    // window.removeEventListener("scroll", this.HandleScroll);
  }

  @Watch("isMobile")
  public isMobileChanged(newVal: boolean) {
    if (!newVal) {
      this.SetDocumentViewOption(DocumentViewOptionType.Paper);
    }
  }

  @Watch("getDocumentLoadingStatus")
  getDocumentLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal === LoadingStatusType.Success) {
      this.isShowMakePayment = false;
      this.SetBeforeGetTransactionRemainPayment();
    }
  }

  @Watch("getMerchantQRPaymentSettingLoadingStatus")
  getMerchantQRPaymentSettingLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal === LoadingStatusType.Success) {
      this.SetIsShowModalMakePayment();
    }
  }

  @Watch("getTransactionRemainPaymentLoadingStatus")
  getTransactionRemainPaymentLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal === LoadingStatusType.Success) {
      if (this.getIsConfirmPayment) {
        this.isShowModalLoadingConfirmPayment = false;
        this.SetShowModalPaymentResponse();
      } else {
        this.SetIsShowMakePayment();
        if (this.isCheckPayment || this.isCheckPaymentAfterCloseModal) {
          this.SetShowModalPaymentResponse(false);
        }
      }
      this.isCheckPayment = false;
      this.isCheckPaymentAfterCloseModal = false;
    } else if (newVal === LoadingStatusType.Loading && this.getIsConfirmPayment) {
      this.isShowModalLoadingConfirmPayment = true;
    } else if (newVal === LoadingStatusType.None) {
      this.SetBeforeGetTransactionRemainPayment();
    }
  }

  public HandleScroll() {
    if (window.scrollY > this.prevScrollY) {
      this.iconOpacity = 40;
    } else {
      this.iconOpacity = 100;
    }
    this.prevScrollY = window.scrollY;
  }

  public SetShowModalPaymentResponse(isShowPaymentFail = true) {
    let paidTotal = this.getTransactionRemainPaymentModel.netAmount - this.getTransactionRemainPaymentModel.paidTotal;
    if (paidTotal > 0 && isShowPaymentFail) {
      this.isShowModalConfirmPaymentFail = true;
    } else if (paidTotal <= 0) {
      this.isShowModalConfirmPaymentSuccess = true;
    }
  }

  public SetBeforeGetTransactionRemainPayment() {
    if (
      (this.getDocumentDetail?.transactionType == TransactionType.Invoice ||
        this.getDocumentDetail?.transactionType == TransactionType.DebitNote ||
        this.getDocumentDetail?.transactionType == TransactionType.BillingNote) &&
      this.getDocumentDetail?.financeType === FinanceType.InFlow &&
      this.getDocumentDetail?.transactionId > 0 &&
      this.merchantDetail.isQrPayment
    ) {
      this.GetTransactionRemainPayment(this.getDocumentDetail?.transactionId, this.getDocumentDetail?.transactionType);
    }
  }

  public OnChangeDisplayType() {
    this.SetDocumentViewOption(this.selectedDocumentViewSettingTypeList);
  }

  public async CheckPayment(isCheckPaymentAfterCloseModal = false) {
    this.isCheckPayment = !isCheckPaymentAfterCloseModal;
    this.isCheckPaymentAfterCloseModal = isCheckPaymentAfterCloseModal;
    await this.DoGetCheckQRPayment();
    if (!this.merchantDetail.isQrPayment) {
      this.isShowMakePayment = false;
      this.isShowModalAlertPartnerNotConnect = true;
    }
    if (this.getDocumentDetail && this.merchantDetail.isQrPayment) {
      this.GetTransactionRemainPayment(
        this.getDocumentDetail.transactionId,
        this.getDocumentDetail.transactionType,
        false
      );
    }
  }

  public SetIsShowModalMakePayment() {
    if (
      this.getMerchantQRPaymentSettingLoadingStatus === LoadingStatusType.Success &&
      this.isSetShowModalMakePayment &&
      this.getDocumentDetail instanceof OnlineViewModel
    ) {
      if (this.merchantDetail.isQrPayment && this.getMerchantQRPaymentModel) {
        switch (this.getMerchantQRPaymentModel.qrPaymentTypeId) {
          case QRPaymentType.Bank:
          case QRPaymentType.SCB:
          case QRPaymentType.Bay:
          case QRPaymentType.Bbl:
            this.isShowModalMakePayment = true;
            break;
          case QRPaymentType.PaySolutions:
            this.isShowModalInfoToConfirmPaymentPaySolutions = true;
            break;
          case QRPaymentType.Beam:
            const postBackUrl = `${process.env.VUE_APP_PeakDocument}${GetURLName(
              this.getDocumentDetail?.transactionId,
              this.getDocumentDetail.financeType
            )}?emi=${MerchantId().PeakEncryption()}&eti=${this.getDocumentDetail.transactionId.PeakEncryption()}&etti=${this.getDocumentDetail.transactionType.PeakEncryption()}&efti=${this.getDocumentDetail.financeType.PeakEncryption()}`;

            this.GetBeamPayment(
              this.getDocumentDetail?.transactionId,
              this.getDocumentDetail.transactionType,
              postBackUrl
            );
            break;
          case QRPaymentType.ChillPay:
            this.isShowModalInfoToConfirmPaymentChillPay = true;
            break;
        }
      } else {
        this.isShowModalAlertPartnerNotConnect = true;
      }
      this.isSetShowModalMakePayment = false;
    }
  }
  public GetBeamPayment(transactionId: number, transactionType: number, postBackUrl: string) {
    const input: BeamRequestModel = {
      transactionId: transactionId,
      transactionTypeId: transactionType,
      onlineViewUrl: postBackUrl,
    };
    this.DoGetBeamPayment(input);
  }

  public GetTransactionRemainPayment(
    transactionId: number,
    transactionType: TransactionType,
    isConfirmPayment = false
  ) {
    let input: GetTransactionRemainPaymentModel = {
      transactionId: transactionId,
      transactionType: transactionType,
      isConfirmPayment: isConfirmPayment,
    };
    this.DoGetTransactionRemainPayment(input);
  }

  public SetIsShowMakePayment() {
    if (
      (this.getDocumentDetail?.transactionType == TransactionType.Invoice ||
        this.getDocumentDetail?.transactionType == TransactionType.DebitNote ||
        this.getDocumentDetail?.transactionType == TransactionType.BillingNote ||
        this.getDocumentDetail?.transactionType == TransactionType.Deposit) &&
      this.getDocumentDetail?.financeType === FinanceType.InFlow &&
      this.merchantDetail.isQrPayment
    ) {
      let paidTotal = this.getTransactionRemainPaymentModel.netAmount - this.getTransactionRemainPaymentModel.paidTotal;
      if (paidTotal > 0) {
        this.isShowMakePayment = true;
        if (this.isCheckPayment) {
          this.StartMakePayment();
        } else if (!this.isCheckPaymentAfterCloseModal) {
          this.CheckIsShowModalQrPayment();
        }
      } else {
        this.isShowMakePayment = false;
      }
    } else {
      this.GetQRPaymentSetting();
    }
  }

  public GetQRPaymentSetting() {
    this.DoGetQRPaymentSetting();
  }

  public StartMakePayment() {
    this.isSetShowModalMakePayment = true;
    this.GetQRPaymentSetting();
  }

  public CheckIsShowModalQrPayment() {
    const isShowPayment = this.$route.query.isShowPayment;
    if (isShowPayment && Boolean(isShowPayment) == true) {
      this.StartMakePayment();
    }
  }

  public ConfirmPayment() {
    const isConfirmPayment = true;
    this.isCheckPaymentAfterCloseModal = true;
    if (this.getDocumentDetail) {
      this.GetTransactionRemainPayment(
        this.getDocumentDetail.transactionId,
        this.getDocumentDetail.transactionType,
        isConfirmPayment
      );
    }
  }

  public RedirectToLogin() {
    window.open(process.env.VUE_APP_PeakAccount);
  }

  public GeneratePdfLogService() {
    let input: DocumentGeneratePdfModel = {
      transactionNumber: this.transactionNumber,
      documentName: this.documentName,
      isDocumentNameShort: this.isDocumentNameShort,
      passCode: "",
      transactionType: this.getDocumentDetail?.transactionType || TransactionType.None,
    };
    this.DoGeneratePdfLogService(input);
  }

  public async PrintDocument() {
    this.GeneratePdfLogService();
    await new Promise((resolve) => {
      window.scrollTo({
        top: 0,
      });
      setTimeout(resolve, 100);
    });
    window.print();
  }

  public CopyLink() {
    this.$emit("copyLink");
  }

  public GeneratePdf() {
    const isClientSideGenerate: boolean = process.env.VUE_APP_CLIENT_GENERATE == 1 ? true : false;
    const allowToClientSideGenerate: boolean = AllowToDownloadClientSide(this.getDocumentDetail?.transactionType);

    let input: DocumentGeneratePdfModel = {
      transactionNumber: this.transactionNumber,
      documentName: this.documentName,
      isDocumentNameShort: this.isDocumentNameShort,
      passCode: "",
      transactionType: this.getDocumentDetail?.transactionType || TransactionType.None,
    };

    if (this.merchantDetail.isUsePassCodeOnPublicLink) {
      if (this.getUserInfo) {
        if (this.getDocumentPassCode === "" && this.getDocumentDetail) {
          let inputUpdatePassCode = {
            transactionType: this.getDocumentDetail.transactionType,
            financeType: this.getDocumentDetail.financeType,
            transactionId: this.getDocumentDetail.transactionId,
            documentUpdatePassCodeType: DocumentUpdatePassCodeType.PrintPdf,
            sourceType: this.sourceType,
          };
          this.DoUpdateOnlineViewPassCode(inputUpdatePassCode);
        } else {
          input.passCode = this.getDocumentPassCode;
          if (isClientSideGenerate && allowToClientSideGenerate) {
            this.DoGeneratePdfClientSide(input);
          } else {
            this.DoGeneratePdf(input);
          }
        }
      } else {
        input.passCode = this.getDocumentPassCode;
        if (isClientSideGenerate && allowToClientSideGenerate) {
          this.DoGeneratePdfClientSide(input);
        } else {
          this.DoGeneratePdf(input);
        }
      }
    } else {
      if (isClientSideGenerate && allowToClientSideGenerate) {
        this.DoGeneratePdfClientSide(input);
      } else {
        this.DoGeneratePdf(input);
      }
    }
  }

  public ToggleShowMenu() {
    this.isShowMenu = !this.isShowMenu;
  }

  @Watch("$i18n.locale")
  langsChanged() {
    if (this.$i18n.locale == "en") {
      this.langs = "th";
    } else {
      this.langs = "en";
    }
  }

  public SetLocate() {
    if (this.langs == "en") {
      this.$i18n.locale = "en";
      this.langs = "th";
    } else {
      this.$i18n.locale = "th";
      this.langs = "en";
    }
  }
}
